"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const address_schema_1 = require("@Entities/schemas/common/address-schema");
const contexts_1 = require("@App/contexts");
const react_hook_form_1 = require("react-hook-form");
const utils_1 = require("@App/common/utils");
const form_field_types_1 = require("@App/enum/form-field-types");
const error_messages_1 = require("@Const/error-messages");
const InnerForm_1 = __importDefault(require("@App/kit/fields/v2/InnerForm"));
const mobx_react_1 = require("mobx-react");
const MailingAddress = (props) => {
    const { libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { watch, setValue, getValues } = (0, react_hook_form_1.useFormContext)();
    const { title = 'Mailing Address', toolTip, subSection, formKey = address_schema_1.addressFormKey } = props;
    const addressFormFields = props.addressFormFields;
    const [countryId, setCountryId] = (0, react_1.useState)(addressFormFields.countryId);
    const [state, setState] = (0, react_1.useState)(addressFormFields.state);
    const [postalCode, setPostalCode] = (0, react_1.useState)(addressFormFields.postalCode);
    const inputName = countryId.parentObjectName ? countryId.parentObjectName + '.' + countryId.name : countryId.name;
    const countryValue = watch(inputName);
    const setOptions = () => {
        setCountryId(Object.assign(Object.assign({}, countryId), { options: libStore.countries }));
    };
    const setOptionsForSelectedCountry = () => {
        var _a;
        if ((0, utils_1.isUSorCanada)(countryValue) && !libStore.doesStateExistInCountry(countryValue, (_a = getValues(formKey)) === null || _a === void 0 ? void 0 : _a.state)) {
            setValue(formKey, Object.assign(Object.assign({}, getValues(formKey)), { state: '' }));
        }
        setState(Object.assign(Object.assign({}, state), { type: (0, utils_1.isUSorCanada)(countryValue) ? form_field_types_1.FormFieldTypes.DROPDOWN : form_field_types_1.FormFieldTypes.TEXT, assistiveText: (0, utils_1.isUSorCanada)(countryValue) ? error_messages_1.REQUIRED_MESSAGE : '', options: libStore.statesForCountryForForm(countryValue) }));
        setPostalCode(Object.assign(Object.assign({}, postalCode), { assistiveText: (0, address_schema_1.isPostcodeRequiredCountry)(countryValue) ? error_messages_1.REQUIRED_MESSAGE : '' }));
    };
    const fieldValidationDependencies = props.linkCityCountryAndAddressFields
        ? [
            {
                dependencies: [addressFormFields.city, addressFormFields.countryId],
                dependOn: addressFormFields.streetAddress,
            },
            {
                dependencies: [addressFormFields.streetAddress, addressFormFields.countryId],
                dependOn: addressFormFields.city,
            },
            {
                dependencies: [addressFormFields.streetAddress, addressFormFields.city],
                dependOn: addressFormFields.countryId,
            },
        ]
        : undefined;
    (0, react_1.useEffect)(() => {
        setOptions();
    }, []);
    (0, react_1.useEffect)(() => {
        setOptionsForSelectedCountry();
    }, [countryValue]);
    return (react_1.default.createElement("div", { className: "mailing-address-wrapper" },
        react_1.default.createElement("h5", null,
            title,
            (0, react_1.isValidElement)(toolTip) && toolTip),
        subSection && subSection,
        react_1.default.createElement("div", { className: "mailing-address" },
            react_1.default.createElement(InnerForm_1.default, { formFields: Object.assign(Object.assign({}, addressFormFields), { countryId,
                    state,
                    postalCode }), fieldValidationDependencies: fieldValidationDependencies }))));
};
exports.default = (0, mobx_react_1.observer)(MailingAddress);
